import React from "react";
import SectionShell from "../../shared/SectionShell";

const splitGridStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 16,
};

const innerSectionStyle = {
  display: "grid",
  gap: 12,
};

const StudentOverviewTab = ({
  formData,
  handleChange,
  fieldGridStyle,
  cardStyle,
  labelStyle,
  inputStyle,
  GENDER_OPTIONS,
  teacherOptions,
  roomOptions,
  gradeOptions,
}) => {
  return (
    <SectionShell
      title="Student Overview"
      subtitle="Core student details, classroom placement, and enrollment status."
    >
      <div style={splitGridStyle}>
        <div style={{ ...cardStyle, ...innerSectionStyle }}>
          <div style={{ fontWeight: 800, fontSize: "1.05rem" }}>Core Details</div>

          <div style={fieldGridStyle}>
            <div>
              <div style={labelStyle}>First Name</div>
              <input
                style={inputStyle}
                value={formData.firstName || ""}
                onChange={(e) => handleChange("firstName", e.target.value)}
                placeholder="Enter first name"
              />
            </div>

            <div>
              <div style={labelStyle}>Last Name</div>
              <input
                style={inputStyle}
                value={formData.lastName || ""}
                onChange={(e) => handleChange("lastName", e.target.value)}
                placeholder="Enter last name"
              />
            </div>

            <div>
              <div style={labelStyle}>Date of Birth</div>
              <input
                type="date"
                style={inputStyle}
                value={formData.dob || ""}
                onChange={(e) => handleChange("dob", e.target.value)}
              />
            </div>

            <div>
              <div style={labelStyle}>Gender</div>
              <select
                style={inputStyle}
                value={formData.gender || ""}
                onChange={(e) => handleChange("gender", e.target.value)}
              >
                {GENDER_OPTIONS.map((option) => (
                  <option key={option || "blank"} value={option}>
                    {option || "Select gender"}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div style={{ ...cardStyle, ...innerSectionStyle }}>
          <div style={{ fontWeight: 800, fontSize: ".98rem" }}>
            Placement & Enrollment
          </div>

          <div style={fieldGridStyle}>
            <div>
              <div style={labelStyle}>Teacher</div>
              <select
                style={inputStyle}
                value={formData.teacher || ""}
                onChange={(e) => handleChange("teacher", e.target.value)}
              >
                <option value="">Select teacher</option>
                {teacherOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <div style={labelStyle}>Room</div>
              <select
                style={inputStyle}
                value={formData.room || ""}
                onChange={(e) => handleChange("room", e.target.value)}
              >
                <option value="">Select room</option>
                {roomOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <div style={labelStyle}>Grade Level</div>
              <select
                style={inputStyle}
                value={formData.gradeLevel || ""}
                onChange={(e) => handleChange("gradeLevel", e.target.value)}
              >
                <option value="">Select grade level</option>
                {gradeOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <div style={labelStyle}>Enrollment Date</div>
              <input
                type="date"
                style={inputStyle}
                value={formData.enrollmentDate || ""}
                onChange={(e) => handleChange("enrollmentDate", e.target.value)}
              />
            </div>

            <div>
              <div style={labelStyle}>Status</div>
              <select
                style={inputStyle}
                value={formData.status || "Active"}
                onChange={(e) => handleChange("status", e.target.value)}
              >
                <option value="Active">Active</option>
                <option value="Pending">Pending</option>
                <option value="Waitlisted">Waitlisted</option>
                <option value="Inactive">Inactive</option>
                <option value="Archived">Archived</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div style={{ ...cardStyle, ...innerSectionStyle }}>
        <div style={{ fontWeight: 800, fontSize: ".98rem" }}>Home Address</div>

        <div>
          <div style={labelStyle}>Address</div>
          <input
            style={inputStyle}
            value={formData.address || ""}
            onChange={(e) => handleChange("address", e.target.value)}
            placeholder="Enter home address"
          />
        </div>
      </div>
    </SectionShell>
  );
};

export default StudentOverviewTab;